<template>
  <view-box
    v-if="$store.state.displayLegendView && initdisplay"
    class="viewboxvisible"
    :heading="$t('legendView.heading')"
    icon="mdi-map-legend"
    style="overflow-y: auto;"
  >
    <div
      class="container pt-3"
      :style="$mq | mq({
        desktop:'width:100%;position: relative;top:0em;'
      })"
    >
      <legend-content />
    </div>
  </view-box>
</template>

<script>

import { Mapable } from '../../mixins/Mapable';

import LegendContent from './LegendContent.vue';
import ViewBox from '../ViewBox.vue';

export default {
  name: 'LegendView',
  components: {
    LegendContent,
    ViewBox,
  },
  mixins: [Mapable],
  data() {
    return {
      initdisplay: this.$appConfig.showLegend,
      baseColor: this.$appConfig.baseColor,
      baseColorAccent: this.$appConfig.baseColorAccent,
      iconColor: this.$appConfig.iconColor,
      fab: false,
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    onMapBound() {
    },
    toggleLegendCard() {
      this.$store.commit('showLegendView');
    },
  },
};

</script>

<style scoped>
#legend-card {
  position: fixed;
  right: 10px;
  top: 10%;
  max-width: 20%;
  min-width: 15%;
  overflow-y: auto;
  height: 60%;
}
.container {
  background-color: transparent;
  visibility: visible;
  /* width: inherit; */
}
@media (min-width: 1250px) {
  .viewboxvisible {
    visibility: visible;
  }
}
</style>
